import axios from 'axios';

export const returnAttributes = async () => {
  try {
    const data = JSON.stringify({
      query: `query {
                    getReturnAttributes {
                        attribute_code
                        label
                        values {
                        option_id
                        label
                        }
                    }
                }`
    });

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://mcstaging.candere.com/graphql',
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      data: data
    };

    const response = await axios.request(config);
    return response.data;

  } catch (error) {
    console.error("Failed to get return attributes:", error);
    return null;
  }
};